import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e2505c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "videos"
}
const _hoisted_2 = {
  key: 1,
  class: "unlock-time"
}
const _hoisted_3 = { class: "title" }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAnniversary, useInfo } from '@/store';
import Swiper from '../base/Swiper.vue';
import PlayBtn from '../base/PlayBtn.vue';
import { Status } from '@/types/enums';
import { filterVideos } from '@/hooks/useFilterVideos';
import { formatTime } from '@/hooks/useTransformTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'Videos',
  setup(__props) {

_useCssVars(_ctx => ({
  "0dc63e14": (_unref(mask).pc[0]),
  "1be46185": (_unref(mask).mobile[0]),
  "0dc63e33": (_unref(mask).pc[1]),
  "1be461a4": (_unref(mask).mobile[1]),
  "3440068f": (_unref(unlockTime).pc),
  "6c64db3e": (_unref(unlockTime).mobile),
  "47075208": (_unref(videoLock).pc)
}))

const { anniversaryVideos } = storeToRefs(useAnniversary());
const filteredVideos = filterVideos(anniversaryVideos.value);

const { getImg } = useInfo();
const mask = computed(() => ({
  pc: [
    `url(${getImg('anniversary_pc_around_mask')})`,
    `url(${getImg('anniversary_pc_bottom_mask')})`,
  ],
  mobile: [
    `url(${getImg('anniversary_mobile_around_mask')})`,
    `url(${getImg('anniversary_mobile_bottom_mask')})`,
  ],
}));
const unlockTime = computed(() => ({
  pc: `url(${getImg('anniversary_pc_unlock_time_bg')})`,
  mobile: `url(${getImg('anniversary_mobile_unlock_time_bg')})`,
}));
const videoLock = computed(() => ({
  pc: `url(${getImg('anniversary_pc_video_lock')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(anniversaryVideos).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(Swiper, {
          list: _unref(filteredVideos),
          prefix: 'cover',
          loop: _unref(filteredVideos).length > 1
        }, {
          item: _withCtx(({ status, coverLandscape, youtubeId, unlockTime, title }) => [
            (status === _unref(Status).Open)
              ? (_openBlock(), _createBlock(PlayBtn, {
                  key: 0,
                  cover: coverLandscape,
                  "youtube-id": youtubeId
                }, null, 8, ["cover", "youtube-id"]))
              : (_openBlock(), _createElementBlock("time", _hoisted_2, _toDisplayString(_unref(formatTime)(unlockTime)), 1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(title), 1)
          ]),
          _: 1
        }, 8, ["list", "loop"])
      ]))
    : _createCommentVNode("", true)
}
}

})